export default __webpack_public_path__ + "static/media/empty-audio.27b5c777.svg";